// removed by extract-text-webpack-plugin
module.exports = {"root":"SwitcherVehicleType-module-root-1afUw","button":"SwitcherVehicleType-module-button-1UFlt","active":"SwitcherVehicleType-module-active-3nqON","icon-car":"SwitcherVehicleType-module-icon-car-365oq","iconCar":"SwitcherVehicleType-module-icon-car-365oq","icon-truck":"SwitcherVehicleType-module-icon-truck-1ZrEu","iconTruck":"SwitcherVehicleType-module-icon-truck-1ZrEu"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SwitcherVehicleType/SwitcherVehicleType.module.scss
// module id = 1022
// module chunks = 0